/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Open_SetsInputs */

const en_us2_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`No sets logged yet`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 set logged`);
	return /** @type {LocalizedString} */ (`${i?.count} sets logged`)
	
};

const pt_br2_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Nenhuma série registrada`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série registrada`);
	return /** @type {LocalizedString} */ (`${i?.count} séries registradas`)
	
};

const es_419_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Todavía no hay series registradas`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie registrada`);
	return /** @type {LocalizedString} */ (`${i?.count} series registradas`)
	
};

const pt_pt2_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Nenhuma série registada`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série registada`);
	return /** @type {LocalizedString} */ (`${i?.count} séries registadas`)
	
};

const fr_fr2_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Aucune série enregistrée pour l'instant`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série enregistrée`);
	return /** @type {LocalizedString} */ (`${i?.count} séries enregistrées`)
	
};

const de_de2_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Noch keine Sätze erfasst`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Satz erfasst`);
	return /** @type {LocalizedString} */ (`${i?.count} Sätze erfasst`)
	
};

const it_it2_workout_open_sets = /** @type {(inputs: Workout_Open_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Ancora nessuna serie registrata`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie registrata`);
	return /** @type {LocalizedString} */ (`${i?.count} serie registrate`)
	
};

/**
* | count | output |
* | --- | --- |
* | "0" | "No sets logged yet" |
* | "1" | "1 set logged" |
* | * | "{count} sets logged" |
*
* @param {Workout_Open_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_sets = /** @type {((inputs: Workout_Open_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_sets(inputs)
	if (locale === "es-419") return es_419_workout_open_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_open_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_open_sets(inputs)
	return en_us2_workout_open_sets(inputs)
});
export { workout_open_sets as "workout.open_sets" }